import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension, CustomFieldExtensionSchema } from '@backstage/plugin-scaffolder-react';
import {
  BillingProductsPicker,
  BillingProductsPickerSchema,
} from './BillingProductsPicker';

export const BillingProductsPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'BillingProductsPicker',
    component: BillingProductsPicker,
    schema: BillingProductsPickerSchema as CustomFieldExtensionSchema,
  }),
);